import { render } from "./AddItemForm.vue?vue&type=template&id=e3cab480"
import script from "./AddItemForm.vue?vue&type=script&lang=js"
export * from "./AddItemForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__